module.exports = __webpack_public_path__ + "static/media/bike.0583797f.png";